<template>
    <div class="content-manage-info">
        <p class="content-title">{{contentInfo.title}}</p>
        <div class="base-info">
            <!-- <a href="https://www.baidu.com" class="source" target="_blank" >跳转：</a> -->
            <a  @click="getUrl(contentInfo.sourceUrl)"  class="source" target="_blank"  :style="{'opacity': contentInfo.source ? '1' : '0'}">来源：{{contentInfo.source}}</a>
            <span class="time">{{$moment(contentInfo.releaseTime).format("YYYY-MM-DD HH:mm")}}</span>
        </div>
        <div class="article-content" v-html="contentInfo.content"></div>
        <div class="other-info">
            <span class="author">责任编辑:{{contentInfo.author}}</span> 
            <span v-if="contentInfo.labelId == 1 || contentInfo.labelId == 2" :class="[{'label': contentInfo.labelId == 1 },{'policy_label': contentInfo.labelId == 2}]">{{contentInfo.labelName}}</span>
            <span class="label" v-if="contentInfo.labelId !== 1 && contentInfo.labelId !== 2" :style="{color: currentLabelColor.color,backgroundColor: currentLabelColor.bg}">{{contentInfo.labelName}}</span>
        </div>
        <div class="attachment-list">
            <p v-for="(item, index) in contentInfo.articleAccessoryEntityList" :key="index" class="attachment-item">
                <img src="../static/link-icon.png"/>
                <a :href="item.accessory">{{item.accessoryName}}</a>
            </p>
        </div>
    </div>
</template>
<script>
    // import MintUI from 'mint-ui';
    import { Toast } from 'mint-ui';
    export default{
        name: 'imageTextInfo',
        props: ['contentInfo', 'currentLabelColor'],
        methods: {
            getUrl(url) {
                console.log('跳转到来源链接：url',url);
                if(url.length>0) {
                    return url;
                } else {
                    Toast('链接无效');
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .content-manage-info{
        box-sizing: border-box;
        border-top: 1px solid #F0F0F0;
        display: flex;
        flex-direction: column;
        padding: 30px;
        line-height: normal;
        .content-title{
            color: #333333;
            // font-size: 32px;
            font-size: 40px;
            margin-bottom: 20px;
            font-weight: bold;
        }
        .base-info{
            display: flex;
            justify-content: space-between;
            font-size: 24px;
            margin-bottom: 30px;
            .source{
                color: #3576E0;
            }
            .time{
                color: #999999;
            }
        }
        .article-content{
            color: #333333;
            font-size: 28px;
            margin-bottom: 36px;
            /deep/ p{
                line-height: normal;
                margin-bottom: 20px;
                img{
                    max-width: 100%;
                    height: auto !important;
                }
            }
        }
        .other-info{
            display: flex;
            justify-content: space-between;
            font-size: 24px;
            margin-bottom: 25px;
            align-items: center;
            .author{
                color: #3576E0;
            }
            //医疗政策
            .label{
                padding: 5px 8px;
                color: #FF9F07;
                background-color: #FFF3CB;
                border-radius: 4px;
            }
            //政策解读
            .policy_label {
                padding: 5px 8px;
                color: #3576E0;
                background-color: #D6EDFF;
                border-radius: 4px;
            }
        }
        .attachment-list{
            .attachment-item{
                font-size: 26px;
                margin-bottom: 10px;
                img{
                    width: 30px;
                    height: 30px;
                    margin-right: 8px;
                }
                a{
                    color: #3576E0;
                }
            }
        }
    }
</style>